import { render, staticRenderFns } from "./OtherFileViewer.vue?vue&type=template&id=fce853e8&"
import script from "./OtherFileViewer.vue?vue&type=script&lang=js&"
export * from "./OtherFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./OtherFileViewer.vue?vue&type=style&index=0&id=fce853e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports